import React from 'react';
export function DangerBanner() {
  return <div className="danger-banner-wrap w-full flex flex-col items-center justify-center my-6 gap-2" data-id="element-55">
      <p className="danger-text-big font-black uppercase text-center leading-tight px-2" data-id="element-56">
        ESTO ES SOLO PARA PERSONAS QUE SE SIENTEN ROTAS FÍSICA Y ESPIRITUALMENTE
        Y NO ENCUENTRAN EL CAMINO
      </p>
    </div>;
}